<div id="loading" *ngIf="showSpinner">
    <div class="container">
        <svg viewBox="0 0 100 100">
            <defs>
                <filter id="shadow">
                    <feDropShadow
                        dx="0"
                        dy="0"
                        stdDeviation="1.5"
                        flood-color="#3561ce"
                    />
                </filter>
            </defs>
            <circle
                class="spinner"
                style="
                    fill: transparent;
                    stroke: #3561ce;
                    stroke-width: 7px;
                    stroke-linecap: round;
                    filter: url(#shadow);
                "
                cx="50"
                cy="50"
                r="45"
            />
        </svg>
    </div>
</div>
